import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Typography, Button } from '@material-ui/core';
import { toast } from 'react-toastify';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeURL } from '../../helperFunctions';
import axios from '../../API/axiosConfig';

const themeColorConfig = {
  green: { backgroundColor: '#19989B', hoverBackgroundColor: '#19878a' },
  yellow: { backgroundColor: '#AB8628', hoverBackgroundColor: '#967217' },
  red: { backgroundColor: '#E45589', hoverBackgroundColor: '#a3375f' },
};

const useStyles = makeStyles(() => ({
  exportButtonWrapper: {
    display: 'flex',
    flexDirection: 'row-reverse',
    backgroundColor: '#FFF',
    paddingTop: '20px',
    paddingBottom: '20px',
    paddingRight: '20px',
  },
  exportButton: props => ({
    display: 'flex',
    padding: '7px 15px',
    borderRadius: '5px',
    alignItems: 'center',
    justifyContent: 'space-around',
    backgroundColor: themeColorConfig[props.type].backgroundColor,
    width: '190px',
    height: '40px',
    '&.MuiButton-root.Mui-disabled': {
      backgroundColor: themeColorConfig[props.type].backgroundColor,
      color: '#fff !important',
    },
    '&:hover': { backgroundColor: themeColorConfig[props.type].hoverBackgroundColor },
  }),
  exportButtonImage: { width: '25px', marginRight: '15px' },
  exportButtonText: { color: 'white', fontSize: '12px', margin: 0 },
  spinner: { color: '#fff' },
}));

const PDFExportButton = ({ type, dashboardType, dashboardId, exportFilters = null, exportContext = null }) => {
  const classes = useStyles({ type });
  const [isLoading, setIsLoading] = useState(false);

  const handleExport = async () => {
    setIsLoading(true);
    try {
      const payload = { id: dashboardId, exportFilters, exportContext };
      const { data } = await axios.post(`/exports/${dashboardType}`, payload, { responseType: 'blob' });
      const blobUrl = window.URL.createObjectURL(new Blob([data], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = `${dashboardType}-report.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (e) {
      let backendMessage = null;
      let backendPayload = null;

      try {
        const blobText = await e?.response?.data?.text?.();
        if (blobText) {
          backendPayload = JSON.parse(blobText);
          backendMessage = backendPayload?.message;
        }
      } catch (err) {
        backendMessage = null;
        backendPayload = null;
      }

      console.log('PDF export failed', {
        status: e?.response?.status,
        backendMessage,
        backendPayload,
      });

      const runtimeErrors = backendPayload?.diagnostics?.pageRuntimeErrors || [];
      const consoleErrors = backendPayload?.diagnostics?.pageConsoleErrors || [];
      const firstDiagnostic = runtimeErrors[0] || consoleErrors[0] || '';

      toast.warn(
        firstDiagnostic
          ? `${backendMessage || 'PDF export failed.'} ${firstDiagnostic}`
          : backendMessage || 'PDF export failed. Please try again.',
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box className={classes.exportButtonWrapper}>
      <Button onClick={handleExport} className={classes.exportButton} disabled={isLoading}>
        {isLoading ? (
          <CircularProgress size={16} className={classes.spinner} />
        ) : (
          <img alt="export-as-pdf" src={makeURL('/images/export-pdf-icon.png')} className={classes.exportButtonImage} />
        )}
        <Typography component="div" variant="button" className={classes.exportButtonText}>
          {isLoading ? 'EXPORTING...' : 'EXPORT PDF'}
        </Typography>
      </Button>
    </Box>
  );
};

export default PDFExportButton;
